export default __webpack_public_path__ + "static/media/IMG_2489.1cf1dbef.jpg";